<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Material Batch No：{{
            formData.materialBatchNo ? formData.materialBatchNo : 'New'
          }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_materialBatchType') || '物料批次类型'"
            prop="materialBatchType"
          >
            <dict-select
              v-model="formData.materialBatchType"
              url="/sys/common/dict/system"
              :body="{ dictType: 'materialBatchType' }"
              size="small"
              clearable
              filterable
              :disabled="!!materialBatchCode"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_materialBatchUnit') || '物料单位'"
          >
            <el-input v-model="formData.materialBatchUnit" clearable>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_ncNo') || 'NC物料编码'">
            <el-input v-model="formData.ncMaterialNo" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_materialCode') || '原始物料编码'"
            prop="materialCode"
          >
            <el-input v-model="formData.materialCode" clearable maxlength="50">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            size="small"
            :label="$l('INDEX.table_label_customer_name') || '客户名称'"
          >
            <dict-select
              clearable
              v-model="formData.custCode"
              :selectedLabel.sync="formData.custName"
              filterable
              url="/master/common/dict/customerSelect"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.table_label_production_order_scm_name') || '供应商名称'
            "
          >
            <dict-select
              size="small"
              clearable
              filterable
              v-model="formData.scmCode"
              :selectedLabel.sync="formData.scmName"
              url="/master/common/dict/scmPartners"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.table_label_order_no') || '订单编号'"
            prop="orderNo"
          >
            <el-input v-model="formData.orderNo" clearable maxlength="50">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.table_label_production_order_goods_no') || '产品编号'
            "
            prop="orderGoodsNo"
          >
            <el-input v-model="formData.orderGoodsNo" clearable maxlength="50">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$l('INDEX.quantity') || '数量'" prop="quantity">
            <el-input-number
              v-model="formData.quantity"
              controls-position="right"
              style="width:100%"
              :max="999999999999.9999"
              :min="0"
              :precision="4"
              v-el-inputnumber-default0
              :step="0.01"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_taxRate') || '税率'"
            prop="taxRate"
          >
            <el-input-number
              v-model="formData.taxRate"
              controls-position="right"
              style="width:100%"
              :precision="2"
              :max="999.99"
              :min="0"
              v-el-inputnumber-default0
              :step="0.01"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_unitPriceTaxIncluded') || '含税单价'"
            prop="unitPriceTaxIncluded"
          >
            <el-input-number
              v-model="formData.unitPriceTaxIncluded"
              controls-position="right"
              style="width:100%"
              :precision="4"
              :max="9999999999999.9999"
              :min="0"
              v-el-inputnumber-default0
              :step="0.01"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_unitPrice') || '不含税单价'"
            prop="unitPrice"
          >
            <el-input-number
              v-model="formData.unitPrice"
              controls-position="right"
              style="width:100%"
              :precision="4"
              :max="9999999999999.9999"
              :min="0"
              v-el-inputnumber-default0
              :step="0.01"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_aoumntTaxIncluded') || '含税金额'"
            prop="aoumntTaxIncluded"
          >
            <el-input-number
              v-model="formData.aoumntTaxIncluded"
              controls-position="right"
              style="width:100%"
              :precision="4"
              :max="9999999999999.9999"
              :min="0"
              v-el-inputnumber-default0
              :step="0.01"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_aoumnt') || '不含税金额'"
            prop="aoumnt"
          >
            <el-input-number
              v-model="formData.aoumnt"
              controls-position="right"
              style="width:100%"
              :precision="4"
              :max="9999999999999.9999"
              :min="0"
              v-el-inputnumber-default0
              :step="0.01"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_hscode') || '海关编码'"
            prop="hscode"
          >
            <el-input v-model="formData.hscode" clearable maxlength="10">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_color') || '颜色'"
            prop="color"
          >
            <el-input v-model="formData.color" clearable maxlength="50">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.table_label_invInCtnQty') || '入数'"
            prop="inCtnQty"
          >
            <el-input-number
              v-model="formData.inCtnQty"
              controls-position="right"
              style="width:100%"
              :precision="0"
              :max="9999999999"
              :min="0"
              v-el-inputnumber-default0
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_hsname') || 'hs品名'"
            prop="hsname"
          >
            <el-input
              v-model="formData.hsname"
              clearable
              size="small"
              rows="1"
              maxlength="255"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_materialBatchName') || '批次物料名称'"
            prop="materialBatchName"
          >
            <el-input
              v-model="formData.materialBatchName"
              clearable
              size="small"
              rows="1"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_materialBatchSpec') || '批次物料规格'"
            prop="materialBatchSpec"
          >
            <el-input
              v-model="formData.materialBatchSpec"
              clearable
              size="small"
              rows="1"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_materialBatchDisplayName') || '物料显示名称'"
            prop="materialBatchDisplayName"
          >
            <el-input
              v-model="formData.materialBatchDisplayName"
              clearable
              size="small"
              rows="1"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <span slot="footer">
        <el-button size="small" @click="cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" v-if="!disabled" @click="save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </div>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    materialBatchCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        materialBatchType: [
          {
            required: true,
            message: '请选择物料批次类型',
            trigger: 'change',
          },
        ],
        materialBatchName: [
          {
            required: true,
            message: '请输入批次物料名称',
            trigger: 'blur',
          },
        ],
        materialBatchSpec: [
          {
            required: true,
            message: '请输入批次物料规格',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.materialBatchCode) return
      this.$api
        .ftyMaterialBatchDetailApi({
          materialBatchCode: this.materialBatchCode,
        })
        .then((res) => {
          const { body } = res
          this.formData = {
            ...body,
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      this.loadingOpen()
      this.$api
        .ftyMaterialBatchSaveApi(this.formData)
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功',
            type: 'success',
          })
          this.$emit('reload')
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
